const shellEn = {
  "admin.shell.AdminSidebar.0": "Dashboard",
  "admin.shell.AdminSidebar.1": "Short links",
  "admin.shell.AdminSidebar.2": "Content",
  "admin.shell.AdminSidebar.3": "Articles",
  "admin.shell.AdminSidebar.4": "Resources",
  "admin.shell.AdminSidebar.5": "Suggestions",
  "admin.shell.AdminSidebar.6": "Members & traffic",
  "admin.shell.AdminSidebar.7": "Members",
  "admin.shell.AdminSidebar.8": "Registration logs",
  "admin.shell.AdminSidebar.9": "Security",
  "admin.shell.AdminSidebar.10": "Security",
  "admin.shell.AdminSidebar.11": "Audit",
  "admin.shell.AdminSidebar.12": "Login attempts",
  "admin.shell.AdminSidebar.13": "Forced challenges",
  "admin.shell.AdminSidebar.14": "IP insights & access",
  "admin.shell.AdminSidebar.15": "Preferences",
  "admin.shell.AdminSidebar.16": "Settings",
  "admin.shell.AdminSidebar.17": "New registration received",
  "admin.shell.AdminSidebar.19": "View site",
  "admin.shell.AdminSidebar.20": "Sign out",
  "admin.shell.AdminSidebar.21": "Sign out",
  "admin.shell.AdminRoute.1": "Checking permissions...",
  "admin.shell.AdminRoute.2": "Access denied",
  "admin.shell.AdminRoute.3": "You do not have permission to access this page.",
  "admin.shell.AdminKPIs.1": "Pending",
  "admin.shell.AdminKPIs.3": "Registrations to process",
  "admin.shell.AdminKPIs.4": "Total registrations",
  "admin.shell.AdminKPIs.6": "All registrations",
  "admin.shell.AdminKPIs.7": "Active members",
  "admin.shell.AdminKPIs.9": "Logged in within 30 days",
  "admin.shell.AdminKPIs.10": "Visits today",
  "admin.shell.AdminKPIs.12": "Since midnight",
  "admin.shell.BulkActionsBar.0": "Grant member access",
  "admin.shell.BulkActionsBar.1": "Send WhatsApp invitation",
  "admin.shell.BulkActionsBar.2": "Send magic link",
  "admin.shell.BulkActionsBar.3": "Change status",
  "admin.shell.BulkActionsBar.4": "Delete",
  "admin.shell.BulkActionsBar.5": "selected",
  "admin.shell.BulkActionsBar.6": "No eligible registrations (all already have a member profile)",
  "admin.shell.BulkActionsBar.7": "Grant access",
  "admin.shell.BulkActionsBar.8": "No eligible registrations",
  "admin.shell.BulkActionsBar.9": "WhatsApp",
  "admin.shell.BulkActionsBar.10": "No eligible registrations (access not approved)",
  "admin.shell.BulkActionsBar.11": "Magic link",
  "admin.shell.BulkActionsBar.12": "Status",
  "admin.shell.BulkActionsBar.14": "Delete",
  "admin.shell.BulkActionsBar.15": "Clear",
  "admin.shell.BulkActionsBar.16": "Bulk action on",
  "admin.shell.BulkActionsBar.17": "registration",
  "admin.shell.BulkActionsBar.18": "selected",
  "admin.shell.BulkActionsBar.20": "eligible",
  "admin.shell.BulkActionsBar.22": "skipped",
  "admin.shell.BulkActionsBar.24": "Pending",
  "admin.shell.BulkActionsBar.25": "Contacted",
  "admin.shell.BulkActionsBar.26": "Added to group",
  "admin.shell.BulkActionsBar.27": "Removed from group",
  "admin.shell.BulkActionsBar.28": "This action cannot be undone.",
  "admin.shell.BulkActionsBar.29": "Sending will be spaced out (~200ms between each) to respect rate limits.",
  "admin.shell.BulkActionsBar.30": "Cancel",
  "admin.shell.BulkActionsBar.32": "In progress...",
  "admin.shell.Admin.1": "Error deleting article",
  "admin.shell.Admin.2": "Article deleted successfully",
  "admin.shell.Admin.3": "Registration growth",
  "admin.shell.Admin.4": "3 months",
  "admin.shell.Admin.5": "6 months",
  "admin.shell.Admin.6": "12 months",
  "admin.shell.Admin.9": "Cumulative growth",
  "admin.shell.Admin.10": "since the beginning",
  "admin.shell.Admin.11": "3 months",
  "admin.shell.Admin.12": "6 months",
  "admin.shell.Admin.13": "12 months",
  "admin.shell.Admin.15": "Cumulative",
  "admin.shell.Admin.16": "Not enough data to display the chart",
  "admin.shell.Admin.17": "Blog articles",
  "admin.shell.Admin.18": "Published",
  "admin.shell.Admin.19": "Scheduled",
  "admin.shell.Admin.22": "New article",
  "admin.shell.Admin.23": "Loading...",
  "admin.shell.Admin.24": "No articles yet",
  "admin.shell.Admin.25": "Create the first article",
  "admin.shell.Admin.26": "No articles in this category.",
  "admin.shell.Admin.29": "📅 Scheduled",
  "admin.shell.Admin.30": "✓ Published",
  "admin.shell.Admin.31": "view",
  "admin.shell.Admin.33": "Preview",
  "admin.shell.Admin.34": "Edit",
  "admin.shell.Admin.35": "Delete",
  "admin.shell.Admin.36": "Confirm deletion",
  "admin.shell.Admin.37": "Are you sure you want to delete this article? This action cannot be undone.",
  "admin.shell.Admin.38": "Cancel",
  "admin.shell.Admin.39": "Delete",
  "admin.shell.nav.Links": "Links",
  "admin.shell.nav.Announcements": "Announcements",
  "admin.shell.nav.Visitors": "Visitors",
  "admin.shell.nav.Canaries": "Canaries",
  "admin.shell.nav.Dashboard": "Dashboard",
  "admin.shell.nav.All": "All",
  "admin.shell.nav.Month": "Month",
  "admin.shell.publication": "Publication on {date}",
  "admin.shell.eligibleCount": "{count} eligible",
  "admin.shell.dashboard.All": "All",
  "admin.shell.dashboard.Max": "Max",
  "admin.shell.over": "over {range}",
  "admin.shell.registrants": "{count} registrations"
} as const;

export default shellEn;
